import * as THREE from "three";
import { servObj } from "./init_glob.js";
import {hideLoaderElement, showLoaderElement} from "./loaderElement.js"
import {textureProgressLoader} from "./textureProgressLoader.js"
const scene = servObj.scene

const house = {
    roofColor: "#272727",
    fasadTexture: "marble-white",
    drainageSystemColor: "#272727",
    windowsDoorsColor: "#272727",
    plinthTexture: "marble-black"
}
servObj.house = house
servObj.defaultHouse = {...house}

const checkHouseInputs = () => {
    document.querySelector(`#house-roof-colors input[value="${servObj.house.roofColor}"]`).checked = true
    document.querySelector(`#house-fasad-textures input[value="${servObj.house.fasadTexture}"]`).checked = true
    document.querySelector(`#drainage-system-colors input[value="${servObj.house.drainageSystemColor}"]`).checked = true
    document.querySelector(`#windows-doors-colors input[value="${servObj.house.windowsDoorsColor}"]`).checked = true
    document.querySelector(`#plinth-textures input[value="${servObj.house.plinthTexture}"]`).checked = true
}
checkHouseInputs()

const applyRoofColor = hex => {
    const color = new THREE.Color(hex)
    servObj.scene.getObjectByName("house_roof").material.color = color
    servObj.house.roofColor = hex
}
const applyFasadTexture = (textureName, isShowLoader = true) => {
    servObj.house.fasadTexture = textureName

    const loaderManager = {

    }

    const calculateTotalProgress = () => {
        // let _total = 1
        // let _loaded = 0
        let answer = 0

        for (let key in loaderManager){
            let total = loaderManager[key].total
            let loaded = loaderManager[key].loaded
            answer += loaded/total / 4
        }

        return answer


    }

    const calculateProgress = () => {
        let total = 1
        let loaded = 0
        let c = 0
        for (let key in loaderManager){
            total += loaderManager[key].total
            loaded += loaderManager[key].loaded
            if(loaderManager[key].total == loaderManager[key].loaded) c++
        }
        if(c == 4){ // IMPORTANT!! CANNOT USE "Object.keys(loaderManager).length"
            setTimeout(() => {
                if(isShowLoader) hideLoaderElement()
                if(isShowLoader) document.querySelector(".preloader_fon").style.width = `0%`
                if(isShowLoader) document.querySelector(".loader-procent").innerText = `0%`
                //cb && cb()
            }, 1000)
        }

        //if(isShowLoader) document.querySelector(".preloader_filled").style.backgroundPosition = `${(1 - calculateTotalProgress()) * 100}% 0`
        if(isShowLoader) document.querySelector(".preloader_fon").style.width = `${calculateTotalProgress() * 100}%`
    }

    if(isShowLoader) showLoaderElement()

    textureProgressLoader(`./textures/house/${textureName}.webp` , map => {
        servObj.scene.getObjectByName("house_walls").material.needsUpdate = true
        servObj.scene.getObjectByName("house_walls").material.map = map

        map.wrapS = THREE.RepeatWrapping
        map.wrapT = THREE.RepeatWrapping
        map.flipY = false
        map.colorSpace = THREE.SRGBColorSpace
        map.anisotropy = 16
        map.offset = new THREE.Vector2(0, -0.4705899953842163)
        map.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)

    }, e => {
        loaderManager["map"] = {total: e.total, loaded: e.loaded}
        calculateProgress()
    })

    textureProgressLoader(`./textures/house/n.webp`, normalMap => {
        servObj.scene.getObjectByName("house_walls").material.normalMap = normalMap

        normalMap.wrapS = THREE.RepeatWrapping
        normalMap.wrapT = THREE.RepeatWrapping
        normalMap.flipY = false
        normalMap.anisotropy = 16
        normalMap.offset = new THREE.Vector2(0, -0.4705899953842163)
        normalMap.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
    }, e => {
        loaderManager["normalMap"] = {total: e.total, loaded: e.loaded}
        calculateProgress()
    })
    textureProgressLoader(`./textures/house/ao.webp`, aoMap => {
        servObj.scene.getObjectByName("house_walls").material.aoMap = aoMap

        aoMap.wrapS = THREE.RepeatWrapping
        aoMap.wrapT = THREE.RepeatWrapping
        aoMap.flipY = false
        aoMap.anisotropy = 16
        aoMap.offset = new THREE.Vector2(0, -0.4705899953842163)
        aoMap.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
    }, e => {
        loaderManager["aoMap"] = {total: e.total, loaded: e.loaded}
        calculateProgress()
    })

    textureProgressLoader(`./textures/house/r_.webp`, roughnessMap => {
        servObj.scene.getObjectByName("house_walls").material.roughnessMap = roughnessMap

        roughnessMap.wrapS = THREE.RepeatWrapping
        roughnessMap.wrapT = THREE.RepeatWrapping
        roughnessMap.flipY = false
        roughnessMap.anisotropy = 16
        roughnessMap.offset = new THREE.Vector2(0, -0.4705899953842163)
        roughnessMap.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
    }, e => {
        loaderManager["roughnessMap"] = {total: e.total, loaded: e.loaded}
        calculateProgress()
    })

    servObj.scene.getObjectByName("house_walls").material.normalScale.x = 1
    servObj.scene.getObjectByName("house_walls").material.normalScale.y = -1
    servObj.scene.getObjectByName("house_walls").material.roughness = .9

    
}
const applyDrainageSystemColor = hex => {
    const color = new THREE.Color(hex)
    servObj.scene.getObjectByName("house_metal_parts").material.color = color
    servObj.house.drainageSystemColor = hex
}
const applyWindowsDoorsColor = hex => {
    const color = new THREE.Color(hex)
    servObj.scene.getObjectByName("house_doors_windows").children[0].material.color = color
    servObj.house.windowsDoorsColor = hex
}
const applyPlinthTexture = (textureName, isShowLoader = true) => {

    const loaderManager = {

    }

    const calculateTotalProgress = () => {
        // let _total = 1
        // let _loaded = 0
        let answer = 0

        for (let key in loaderManager){
            let total = loaderManager[key].total
            let loaded = loaderManager[key].loaded
            answer += loaded/total / 4
        }

        return answer


    }

    const calculateProgress = () => {
        let total = 1
        let loaded = 0
        let c = 0
        for (let key in loaderManager){
            total += loaderManager[key].total
            loaded += loaderManager[key].loaded
            if(loaderManager[key].total == loaderManager[key].loaded) c++
        }
        if(c == 4){ // IMPORTANT!! CANNOT USE "Object.keys(loaderManager).length"
            setTimeout(() => {
                if(isShowLoader) hideLoaderElement()
                if(isShowLoader) document.querySelector(".preloader_fon").style.width = `0%`
                if(isShowLoader) document.querySelector(".loader-procent").innerText = `0%`
                //cb && cb()
            }, 1000)
        }

        //if(isShowLoader) document.querySelector(".preloader_filled").style.backgroundPosition = `${(1 - calculateTotalProgress()) * 100}% 0`
        if(isShowLoader) document.querySelector(".preloader_fon").style.width = `${calculateTotalProgress() * 100}%`
    }

    if(isShowLoader) showLoaderElement()

    servObj.house.plinthTexture = textureName

    textureProgressLoader(`./textures/house/${textureName}.webp`, map => {
        servObj.scene.getObjectByName("house_plinth").material.needsUpdate = true
        servObj.scene.getObjectByName("house_plinth").material.map = map

        map.wrapS = THREE.RepeatWrapping
        map.wrapT = THREE.RepeatWrapping
        map.flipY = false
        map.colorSpace = THREE.SRGBColorSpace
        map.anisotropy = 16
        map.offset = new THREE.Vector2(0, -0.4705899953842163)
        map.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
    }, e => {
        loaderManager["map"] = {total: e.total, loaded: e.loaded}
        calculateProgress()
    })
    textureProgressLoader(`./textures/house/n.webp`, normalMap => {
        servObj.scene.getObjectByName("house_plinth").material.normalMap = normalMap

        normalMap.wrapS = THREE.RepeatWrapping
        normalMap.wrapT = THREE.RepeatWrapping
        normalMap.flipY = false
        normalMap.anisotropy = 16
        normalMap.offset = new THREE.Vector2(0, -0.4705899953842163)
        normalMap.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
    }, e => {
        loaderManager["normalMap"] = {total: e.total, loaded: e.loaded}
        calculateProgress()
    })
    textureProgressLoader(`./textures/house/ao.webp`, aoMap => {
        servObj.scene.getObjectByName("house_plinth").material.aoMap = aoMap

        aoMap.wrapS = THREE.RepeatWrapping
        aoMap.wrapT = THREE.RepeatWrapping
        aoMap.flipY = false
        aoMap.anisotropy = 16
        aoMap.offset = new THREE.Vector2(0, -0.4705899953842163)
        aoMap.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
    }, e => {
        loaderManager["aoMap"] = {total: e.total, loaded: e.loaded}
        calculateProgress()
    })
    textureProgressLoader(`./textures/house/r_.webp`, roughnessMap => {
        servObj.scene.getObjectByName("house_plinth").material.roughnessMap = roughnessMap

        roughnessMap.wrapS = THREE.RepeatWrapping
        roughnessMap.wrapT = THREE.RepeatWrapping
        roughnessMap.flipY = false
        roughnessMap.anisotropy = 16
        roughnessMap.offset = new THREE.Vector2(0, -0.4705899953842163)
        roughnessMap.repeat = new THREE.Vector2(1.3333333730697632, 1.470588207244873)
    }, e => {
        loaderManager["roughnessMap"] = {total: e.total, loaded: e.loaded}
        calculateProgress()
    })

    servObj.scene.getObjectByName("house_plinth").material.normalScale.x = 1
    servObj.scene.getObjectByName("house_plinth").material.normalScale.y = -1
    servObj.scene.getObjectByName("house_plinth").material.roughness = .9

    
}

document.querySelector("#house-roof-colors").addEventListener("change", e => applyRoofColor(e.target.value))
document.querySelector("#house-fasad-textures").addEventListener("change", e => applyFasadTexture(e.target.value))
document.querySelector("#drainage-system-colors").addEventListener("change", e => applyDrainageSystemColor(e.target.value))
document.querySelector("#windows-doors-colors").addEventListener("change", e => applyWindowsDoorsColor(e.target.value))
document.querySelector("#plinth-textures").addEventListener("change", e => applyPlinthTexture(e.target.value))

export {applyRoofColor, applyFasadTexture, applyDrainageSystemColor, applyWindowsDoorsColor, applyPlinthTexture, checkHouseInputs}